import { render, staticRenderFns } from "./editStorebrand.vue?vue&type=template&id=90861abe&scoped=true"
import script from "./editStorebrand.vue?vue&type=script&lang=js"
export * from "./editStorebrand.vue?vue&type=script&lang=js"
import style0 from "./editStorebrand.vue?vue&type=style&index=0&id=90861abe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90861abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90861abe')) {
      api.createRecord('90861abe', component.options)
    } else {
      api.reload('90861abe', component.options)
    }
    module.hot.accept("./editStorebrand.vue?vue&type=template&id=90861abe&scoped=true", function () {
      api.rerender('90861abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/storeBrand/editStorebrand.vue"
export default component.exports